module.exports = __webpack_public_path__ + "static/favicon-650a80785a6ebae8e2550eb17efe4cac.png";